import {createAction, handleActions} from 'redux-actions';
import * as api from '../services/api';

// regular actions
const SET = '@translationtool/engine/SET';

const set  = createAction(SET, labelCollections => labelCollections);

export const reducer = handleActions(
	{
		[SET]: (state, action) => {
			return {...action.payload};
		},
	},
	{
		queuedJobs: [],
		executingJobs: [],
		successfulJobs: [],
		failedJobs: [],
	}
);

// thunks
const fetch = () => (dispatch) => {
	return api.fetchJobs().then(
		response => dispatch(set(response.data.data)),
		error => console.log(error)
	);
};

const retry = (jobid) => (dispatch) => {
	return api.retryJobs(jobid).then(
		response => dispatch(set(response.data.data)),
		error => console.log(error)
	);
};

const remove = (jobid) => (dispatch) => {
    return api.removeJob(jobid).then(
        response => dispatch(set(response.data.data)),
        error => console.log(error)
    );
};

const removeAll = () => (dispatch) => {
    return api.removeAllJobs().then(
        response => dispatch(set(response.data.data)),
        error => console.log(error)
    );
}

// public actions
export const actions = {
	fetch, retry, remove, removeAll
};



// WEBPACK FOOTER //
// ./React/src/reducers/engine.js